<template>
  <div class="connection-status" :class="statusClass">
    <div class="connection-status-content">
      <v-icon :size="16" :color="iconColor">{{ statusIcon }}</v-icon>
      <span class="connection-status-text">{{ statusText }}</span>
      <button v-if="showRetry" @click="handleRetry" class="connection-retry-btn">
        تلاش مجدد
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConnectionStatus',
  props: {
    status: {
      type: String,
      default: 'connected', // connected, connecting, disconnected, offline
      validator: (value) => ['connected', 'connecting', 'disconnected', 'offline'].includes(value)
    }
  },
  computed: {
    statusClass() {
      return `connection-status-${this.status}`;
    },
    statusIcon() {
      switch (this.status) {
        case 'connected':
          return 'mdi-check-circle';
        case 'connecting':
          return 'mdi-loading';
        case 'disconnected':
          return 'mdi-alert-circle';
        case 'offline':
          return 'mdi-wifi-off';
        default:
          return 'mdi-help-circle';
      }
    },
    iconColor() {
      switch (this.status) {
        case 'connected':
          return '#4CAF50';
        case 'connecting':
          return '#FF9800';
        case 'disconnected':
        case 'offline':
          return '#F44336';
        default:
          return '#9E9E9E';
      }
    },
    statusText() {
      switch (this.status) {
        case 'connected':
          return 'متصل';
        case 'connecting':
          return 'در حال اتصال...';
        case 'disconnected':
          return 'اتصال قطع شد';
        case 'offline':
          return 'آفلاین';
        default:
          return '';
      }
    },
    showRetry() {
      return this.status === 'disconnected' || this.status === 'offline';
    }
  },
  methods: {
    handleRetry() {
      this.$emit('retry');
    }
  }
}
</script>

<style scoped>
.connection-status {
  padding: 8px 16px;
  background: #fff3cd;
  border-bottom: 1px solid #ffc107;
  display: flex;
  align-items: center;
  justify-content: center;
  direction: rtl;
  animation: slideDown 0.3s ease-out;
}

.connection-status-connecting {
  background: #fff3cd;
  border-bottom-color: #ffc107;
}

.connection-status-disconnected,
.connection-status-offline {
  background: #ffebee;
  border-bottom-color: #f44336;
}

.connection-status-connected {
  background: #e8f5e9;
  border-bottom-color: #4caf50;
  display: none; /* Hide when connected */
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.connection-status-content {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #424242;
}

.connection-status-text {
  font-weight: 500;
}

.connection-retry-btn {
  background: transparent;
  border: 1px solid currentColor;
  border-radius: 12px;
  padding: 4px 12px;
  font-size: 12px;
  cursor: pointer;
  color: #424242;
  transition: all 0.2s ease;
  margin-right: 8px;
}

.connection-retry-btn:hover {
  background: rgba(0, 0, 0, 0.05);
}
</style>


